import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { provideValueAccessor } from '@sama/ng-core';
import { shellConnectorToken } from '../../team-apis/core/shell-connector';
import {
  AbstractTool,
  toolNameForEventTracking,
} from '../annotation/shared/abstract-tool';
import { ToggleButton } from '../components/toggle-button-group/toggle-button-group.component';
import { AbstractWrappedFormControl } from '../forms/basic-inputs/abstract-wrapped-form-control';
import { KeyboardShortcutService } from '../misc-services/keyboard-shortcut.service';

@Component({
  selector: 'h3-tool-mode',
  templateUrl: './tool-mode.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideValueAccessor(ToolModeComponent)],
  standalone: false,
})
export class ToolModeComponent
  extends AbstractWrappedFormControl<string>
  implements OnInit
{
  @Input({ required: true }) tool!: AbstractTool;
  @Input({ required: true }) buttons!: ToggleButton[];
  @Input({ required: true }) eventBucket!: string;

  private shellConnector = inject(shellConnectorToken);
  private keyboardShortcutService = inject(KeyboardShortcutService);

  override ngOnInit() {
    super.ngOnInit();
    this.setUpListener();
  }

  trackEvent(source: string) {
    this.shellConnector.trackEvent({
      id: 'change_tool_mode',
      bucket: this.eventBucket,
      mode: this.control.value,
      source,
      tool: toolNameForEventTracking(this.tool.name),
    });
  }

  private setMode(mode: string) {
    this.control.setValue(mode, { emitEvent: true });
  }

  private selectNextMode(source: string) {
    const nextModeIndex =
      (this.getModeIndex(this.control.value) + 1) % this.buttons.length;
    this.setMode(this.buttons[nextModeIndex].value);

    this.trackEvent(source);
  }

  private getModeIndex(mode: string) {
    return this.buttons.findIndex((button) => button.value === mode);
  }

  private setUpListener() {
    this.subscribeTo(
      this.keyboardShortcutService.getMatchingEvent$(this.tool.shortcutName),
      () => this.selectNextMode('keyboard_shortcut'),
    );
  }
}
